import { render, staticRenderFns } from "./solo_premium.vue?vue&type=template&id=245c0a6d"
import script from "./solo_premium.vue?vue&type=script&lang=js"
export * from "./solo_premium.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports